import styled from 'styled-components';

export const Body = styled.div`
  flex: 1;
  margin-left: 2rem;
`;

export const Name = styled.h3`
  font-weight: ${({ theme: { fonts } }) => fonts.weight.thick};
  font-size: ${({ theme: { fonts } }) => fonts.size.big};
`;

export const Resume = styled.h3`
  color: ${({ theme: { palette } }) => palette.darkGrey};

  font-size: ${({ theme: { fonts } }) => fonts.size.medium};
`;



// WEBPACK FOOTER //
// ./src/components/MyCsm/elements.js